export const isOrganisationGroupUser = (userData) =>
  Boolean(userData?.organisationGroupId?._id);

export const getAuthenticatedHomeRoute = (userData) =>
  isOrganisationGroupUser(userData)
    ? "/organisations/dashboard"
    : "/Dashboard";

export const isAllowedAuthenticatedRoute = (pathname, userData) => {
  if (!pathname) return false;

  const isOrganisationRoute = pathname.startsWith("/organisations");
  return isOrganisationRoute === isOrganisationGroupUser(userData);
};
